'use client';
/** @jsxImportSource @emotion/react */

import type { GridProps } from '@mui/material/Grid';

import MuiGrid from '@mui/material/Grid';

/**
 * @deprecated Please use `GridProps` and `GridItemProps` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-grid-migration--grid-migration-guide Migration guide}
 */
export type { GridProps };

/**
 * @deprecated Please use `Grid` and `Grid.Item` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-grid-migration--grid-migration-guide Migration guide}
 */
export const Grid = MuiGrid;
